import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  ValidatedPanel,
  TextTitle,
  getPanelErrorProps,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { getUrlOptionsDetails } from '@bingads-webui-campaign-react/url-options';
import { ValidatedUrlOptionsParameter } from './validated-url-options';
import UrlOptionsImg from '../media/campaign-url-options.svg';

export const URLOptionsSection = ({
  expand,
  trackingUrlTemplate,
  finalUrlSuffix,
  urlCustomParameters,
  token,
  triggerTestUurl,
  ...rest
}) => {
  const i18n = useContext(I18nContext);
  const urlOptions = useMemo(() => ({
    TrackingUrlTemplate: trackingUrlTemplate,
    FinalUrlSuffix: finalUrlSuffix,
    UrlCustomParameters: urlCustomParameters,
  }), [finalUrlSuffix, trackingUrlTemplate, urlCustomParameters]);
  const urlOptionsDetails = useMemo(() => getUrlOptionsDetails(i18n, urlOptions), [urlOptions, i18n]);

  return (
    <ValidatedPanel
      key="advanced-url-options"
      title={<TextTitle titleKey={_TL_('Advanced URL options')} details={urlOptionsDetails} icon={UrlOptionsImg} />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'advanced-url-options',
      }}
      {...rest}
    >
      <span className="url-options-descriptions">
        {i18n.getString(_TL_('Set up the tracking and redirect information for your ads.'))}
      </span>
      <ValidatedUrlOptionsParameter
        i18n={i18n}
        validationProps={{
          initialValue: urlOptions,
          data: urlOptions,
        }}
        triggerTestUurl={triggerTestUurl}
        token={token}
        isControlledOutside
        showUurlTestTool
      />
    </ValidatedPanel>
  );
};

URLOptionsSection.propTypes = {
  expand: PropTypes.func.isRequired,
  finalUrlSuffix: PropTypes.string,
  trackingUrlTemplate: PropTypes.string,
  urlCustomParameters: PropTypes.arrayOf(PropTypes.shape({})),
  token: PropTypes.string.isRequired,
  triggerTestUurl: PropTypes.func.isRequired,
};

URLOptionsSection.defaultProps = {
  finalUrlSuffix: undefined,
  trackingUrlTemplate: undefined,
  urlCustomParameters: undefined,
};
